module.exports = __webpack_public_path__ + "img/Ruler-measure.4f18f3a5.svg";